import React, { Component } from 'react';
import Home from './Home.js';
import CreateProject from './CreateProject.js';
import ProjectDetail from './ProjectDetail.js';
import TaskDetail from './TaskDetail.js';
import './App.css';

import {
  Route,
  Switch
} from 'react-router-dom'

class App extends Component {
  render() {
    return (
      <div className="app">
        <Switch>
          <Route exact path="/" component={Home}/>
          <Route path="/create-project" component={CreateProject}/>
          <Route exact path="/projects/:projectId" component={ProjectDetail}/>
          <Route exact path="/projects/:projectId/solutions/:solutionId/tasks/:taskId" component={TaskDetail}/>
        </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js